module.exports = __webpack_public_path__ + "static/media/c3.f2683c16.png";